module.exports = __webpack_public_path__ + "img/icon2.6d61c05f.svg";